// This file is auto-generated. Do not edit!

export default [
  {
    id: "0x1350994173f1CC83f8fc45a5aF80A0aCfC1B613C",
    version: "v1.1",
    name: "vaultname",
    symbol: "symbol",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xe01133083c34CDEc8A6722b1C8E9EC3c5A46AE86",
    version: "v1.1",
    name: "Storm USDC",
    symbol: "stormUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x2A177A2C0D54d445f5a06F67d97f79FdC73B3534",
    version: "v1.1",
    name: "Honor Vault",
    symbol: "honorUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xa9D11e0e1356d13d18edd9DBd7b0352464256b33",
    version: "v1.1",
    name: "Test Vault 2",
    symbol: "testVault2",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xfDaD9e039e2a5458E75F2BD4a0952456bd25ce9B",
    version: "v1.1",
    name: "Finz Vault",
    symbol: "finzVault",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x7d27402FD0401F62709100e43a99e6EB4740c970",
    version: "v1.1",
    name: "Test Vault 3",
    symbol: "testVault3",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x1A461ebED31fE0fa36D91C9E09528837BaCca43a",
    version: "v1.1",
    name: "Test Vault 4",
    symbol: "testVault4",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xEC2Cf9ca3A579d5C170187534F585fe92d288aE0",
    version: "v1.1",
    name: "Test Vault 5",
    symbol: "testVault5",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x563B46Cddd026Ee909C75eF5D125A94136799Ac1",
    version: "v1.1",
    name: "Vaulty Vault",
    symbol: "vv",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x16Cd9De749627eB65EeDBa35548D61D915815F89",
    version: "v1.1",
    name: "MS-sUSDe",
    symbol: "MUX-V3 Senior Tranche sUSDe",
    asset: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
  },
  {
    id: "0x24717fDDD4FDF9DffA856D8A7F1A41D2b9dE9dEC",
    version: "v1.1",
    name: "testWbtc",
    symbol: "TCWBTC",
    asset: {
      address: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
      symbol: "WBTC",
    },
  },
  {
    id: "0x99654C53728B36f6b96063dB7B0d6Dc4116a66cf",
    version: "v1.1",
    name: "testusdc1",
    symbol: "usdctt",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x137525c9c78f5fd675138568318A19126aFb436b",
    version: "v1.1",
    name: "sail USDC",
    symbol: "sjUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x696565124BfC7Cf6CCd9194Ef949799cF21069e8",
    version: "v1.1",
    name: "TEST WETH VAULT",
    symbol: "test-weth-vault",
    asset: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0xbE1A0690Aa440ccaE131B05679aeF197f843527a",
    version: "v1.1",
    name: "MS-sUSDe",
    symbol: "MUX-V3 Senior Tranche sUSDe",
    asset: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
  },
  {
    id: "0xBD14bEa2eCECeCD5F32149B0f84BE7f7F446B964",
    version: "v1.1",
    name: "Gauntlet WETH Core",
    symbol: "gtWETH",
    asset: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0x7c574174DA4b2be3f705c6244B4BfA0815a8B3Ed",
    version: "v1.1",
    name: "Gauntlet USDC Prime",
    symbol: "gtUSDCp",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x7e97fa6893871A2751B5fE961978DCCb2c201E65",
    version: "v1.1",
    name: "Gauntlet USDC Core",
    symbol: "gtUSDCc",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x139250CdB310D657eAC506c7C7FC6AcDE34Af1ec",
    version: "v1.1",
    name: "Gauntlet USDT0 Core",
    symbol: "gtUSDT0",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0x4dB0B0a83de352817d0C30a88a36667b75D48b6E",
    version: "v1.1",
    name: "test do not use",
    symbol: "testWETH",
    asset: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0x250CF7c82bAc7cB6cf899b6052979d4B5BA1f9ca",
    version: "v1.1",
    name: "Steakhouse Prime USDC",
    symbol: "steakUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x0623a67D69bB2F59D266897A15dC1509d291D631",
    version: "v1.1",
    name: "Steakhouse Prime ETH",
    symbol: "steakETH",
    asset: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0x87DEAE530841A9671326C9D5B9f91bdB11F3162c",
    version: "v1.1",
    name: "Yearn OG USDC",
    symbol: "yOG-USDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x3574B6b307f86C0ca6bd263dCa12d8f3031e57B9",
    version: "v1.1",
    name: "Yearn OG WETH",
    symbol: "yOG-WETH",
    asset: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0x2281961480216653529A03D6CE03Ee6B8cdF564E",
    version: "v1.1",
    name: "Steakhouse Prime USDT0",
    symbol: "steakUSDT0",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0x6d57dAd0F1c4da0C1d5443AE8F7f8a50BDb9Cf75",
    version: "v1.1",
    name: "MEV Capital USDT0",
    symbol: "MCUSDT0",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0xa60643c90A542A95026C0F1dbdB0615fF42019Cf",
    version: "v1.1",
    name: "MEV Capital USDC",
    symbol: "MCUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x9B33073eB98A9a1eb408DedcD08616fE850b3f09",
    version: "v1.1",
    name: "MEV Capital wETH",
    symbol: "MCwETH",
    asset: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0x4C289073eb6679393890b85eEC9D604271c18c28",
    version: "v1.1",
    name: "Alpha USDC Core",
    symbol: "aUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x23fafF4F253B85834D9d37f97EA807EC46d1Ec9E",
    version: "v1.1",
    name: "Alpha wETH Core",
    symbol: "aWETH",
    asset: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0x0f841BD670eaeB6bE0a173C06EFEfBAD09ABB0f4",
    version: "v1.1",
    name: "Alpha USDT Core",
    symbol: "aUSDT",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0xf56932d6bd0b99aadD8B77117e08374A14520dbE",
    version: "v1.1",
    name: "Tridust USDC",
    symbol: "tdUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x5c0C306Aaa9F877de636f4d5822cA9F2E81563BA",
    version: "v1.1",
    name: "Steakhouse High Yield USDC",
    symbol: "bbqUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x4739E2c293bDCD835829aA7c5d7fBdee93565D1a",
    version: "v1.1",
    name: "Steakhouse High Yield USDT0",
    symbol: "bbqUSDT0",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0x9948364c08B28270b0463377a3B7cB49c630e9c7",
    version: "v1.1",
    name: "bratset",
    symbol: "bratset",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x64A651D825FC70Ebba88f2E1BAD90be9A496C4b9",
    version: "v1.1",
    name: "Avantgarde USDC Core Arbitrum",
    symbol: "AVGUSDCCOREarb",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x9257eDDa03f9915857187e927eF501c53b1679b3",
    version: "v1.1",
    name: "Avantgarde USDC Prime Arbitrum",
    symbol: "AVGUSDCPRIMEarb",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x704761B6280BfABC7E397EfD34Fc15cd3b527d7D",
    version: "v1.1",
    name: "Re7 USDC",
    symbol: "Re7USDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x3820B4a0309280D2DbFCe37Ce4a72a4200ef0E13",
    version: "v1.1",
    name: "Dojo USDC",
    symbol: "USDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x26f9C07c6c7c4fC18C9fbb0DD852a9e2c060B36e",
    version: "v1.1",
    name: "sft USDC test",
    symbol: "sfUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xe349f4114E8588469FdbC68FAE326a50517E40FB",
    version: "v1.1",
    name: "SingularV USDC",
    symbol: "svUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x62Eb3dB2A6d0BE24c5538414189d3F75Ab7110F2",
    version: "v1.1",
    name: "SingularV ETH",
    symbol: "svETH",
    asset: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0x4B6F1C9E5d470b97181786b26da0d0945A7cf027",
    version: "v1.1",
    name: "Hyperithm USDC Apex",
    symbol: "hyperUSDCa",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x5579e27129110bBC9c0eC1388aCBf7ad04771b76",
    version: "v1.1",
    name: "dForce USDC",
    symbol: "dForce USDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xa53Cf822FE93002aEaE16d395CD823Ece161a6AC",
    version: "v1.1",
    name: "Clearstar USDC Reactor",
    symbol: "CSUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xB34e17733245c7371E87E9DF64E705000B91D169",
    version: "v1.1",
    name: "Duplicated Key Arbitrum",
    symbol: "DPK.Arb",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x6cA1814AF943d3A796090aB5b098A68FB4cBC990",
    version: "v1.1",
    name: "MetaMorphoV1_1",
    symbol: "MM11",
    asset: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
  },
  {
    id: "0xE2fddc23AB85C83c16b0d5429A4dEc6F147454AA",
    version: "v1.1",
    name: "MetaMorphoV1_1",
    symbol: "MM11",
    asset: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
  },
  {
    id: "0x671739Ea595C42AC506d35709e613aFca3a1E01a",
    version: "v1.1",
    name: "losemoney-usdc",
    symbol: "loser",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x36b69949d60d06ECcC14DE0Ae63f4E00cc2cd8B9",
    version: "v1.1",
    name: "Yearn Degen USDC",
    symbol: "yDG-USDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x3014ED70B39be395e1a5Eb8ab4c4b8a5378E6522",
    version: "v1.1",
    name: "Not Gauntlet",
    symbol: "AUSD",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xba473dE3EAA8E6d9D603cC9Ed2f78983Bfd10A30",
    version: "v1.1",
    name: "Naga Vault",
    symbol: "NAGAVAULT",
    asset: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
  },
  {
    id: "0x37997418Ef10F0DB0B38A411877De1e17e0B2058",
    version: "v1.1",
    name: "MS-sUSDC",
    symbol: "MUX-V3 Senior Tranche sUSDC",
    asset: {
      address: "0x940098b108fB7D0a7E374f6eDED7760787464609",
      symbol: "sUSDC",
    },
  },
  {
    id: "0xDC2f46e34d06e8F982000cca8253e9ea6529598D",
    version: "v1.1",
    name: "RIMU USDC Core",
    symbol: "RIMUusdcCore",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x44Dd55b94223077386C351dae154AD107bAC31E4",
    version: "v1.1",
    name: "TryVault",
    symbol: "TV",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0x2C609d9CfC9dda2dB5C128B2a665D921ec53579d",
    version: "v1.1",
    name: "kpk USDC Yield",
    symbol: "kpk_USDC_Yield",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x320A3D53AB1Ae0A4B8E324F4C74bd04d1cFe0CFf",
    version: "v1.1",
    name: "Super USDC",
    symbol: "supUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xe9C36f2F6e44e0836Ac1da5C7c1EbCac1465c80E",
    version: "v1.1",
    name: "AA Quad USDT0 Vault",
    symbol: "aaUSDT0",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0x37492b884Cb8f47A630D8DBBa62B459F79996e9f",
    version: "v1.1",
    name: "AA Quad USDC Vault",
    symbol: "aaUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x6ed386Ee386199D0E1D9D712Ef2071bE433844F4",
    version: "v1.1",
    name: "ABRC",
    symbol: "abrc",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x64CA76e2525fc6Ab2179300c15e343d73e42f958",
    version: "v1.1",
    name: "Clearstar High Yield USDC",
    symbol: "CSHYUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x1ee4Add09635515628a94B2A8B26c71Ec7d58B29",
    version: "v1.1",
    name: "Naga Vault",
    symbol: "NAGAVAULT",
    asset: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
  },
  {
    id: "0x0136bc523cA620d9D8a85aF6c8a051eE004c32BE",
    version: "v1.1",
    name: "Naga Vault",
    symbol: "NAGAVAULT",
    asset: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
  },
  {
    id: "0x9D1005A902A7D9C4f24ebc3b0CB3Bbf6F2c85F30",
    version: "v1.1",
    name: "Naga Vault",
    symbol: "NAGAVAULT",
    asset: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
  },
  {
    id: "0x59Db78948dC41A8c23b22803c312EaB0ecf8D0DB",
    version: "v1.1",
    name: "Naga Vault",
    symbol: "NAGAVAULT",
    asset: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
  },
  {
    id: "0xEC957BC43dBa57aBFCA4518d6F1aA28e443BAc26",
    version: "v1.1",
    name: "Naga Vault",
    symbol: "NAGAVAULT",
    asset: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
  },
  {
    id: "0xbe3F0374d673ec95140913aF83eC3fee26344E14",
    version: "v1.1",
    name: "Naga Vault",
    symbol: "NAGAVAULT",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x664A88cC97e23582744f53D1a575daB091396d19",
    version: "v1.1",
    name: "Naga Vault",
    symbol: "NAGAVAULT",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0xe70934e06150Dc85594b94A453a99233622a7861",
    version: "v1.1",
    name: "Naga Vault",
    symbol: "NAGAVAULT",
    asset: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
  },
  {
    id: "0x300E922054EF443199E39CC151e84f3D97b936fa",
    version: "v1.1",
    name: "Naga Vault",
    symbol: "NAGAVAULT",
    asset: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
  },
  {
    id: "0x64D4e6d8D030b6B7Fc6c34f6222D5A392c2B4294",
    version: "v1.1",
    name: "Naga Vault",
    symbol: "NAGAVAULT",
    asset: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
  },
  {
    id: "0x596Cde05ff90c826695B9080fc792e562f3b235c",
    version: "v1.1",
    name: "Naga Vault",
    symbol: "NAGAVAULT",
    asset: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
  },
  {
    id: "0xe32f77a13CE050b3D4c4B43935edE955609C33b1",
    version: "v1.1",
    name: "Naga Vault",
    symbol: "NAGAVAULT",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x981a7B6eC71D2b92EB976ba5b7901628d7fEA048",
    version: "v1.1",
    name: "Naga Vault",
    symbol: "NAGAVAULT",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0x76B2406D29F1A2Be4DB638aBBD5c7Cab2eE2D8FE",
    version: "v1.1",
    name: "Vaultik USDC",
    symbol: "vUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xeFc0c886e51d1d0bbeA780A5e2442Cf3947acB74",
    version: "v1.1",
    name: "Blend Euler Earn USDC V1",
    symbol: "blend-eeUSDC-v1",
    asset: {
      address: "0xe4783824593a50Bfe9dc873204CEc171ebC62dE0",
      symbol: "eeUSDC",
    },
  },
  {
    id: "0xDf8EdA1E84E610B550ff46CE0a81364807bA243B",
    version: "v1.1",
    name: "Blend Hyperithm USDC V1",
    symbol: "blend-hyperUSDC-v1",
    asset: {
      address: "0x4B6F1C9E5d470b97181786b26da0d0945A7cf027",
      symbol: "hyperUSDC",
    },
  },
  {
    id: "0x6417ce2f7c8F6DA9A031D53F87e53dC554D8aD7c",
    version: "v1.1",
    name: "Blend Gauntlet USDC Core V1",
    symbol: "blend-gtUSDCc-v1",
    asset: {
      address: "0x7e97fa6893871A2751B5fE961978DCCb2c201E65",
      symbol: "gtUSDCc",
    },
  },
  {
    id: "0xA19db1af5d973397DE74f68b5a13A38Caa81f16E",
    version: "v1.1",
    name: "Blend MEV Capital USDC V1",
    symbol: "blend-MCUSDC-v1",
    asset: {
      address: "0xa60643c90A542A95026C0F1dbdB0615fF42019Cf",
      symbol: "MCUSDC",
    },
  },
  {
    id: "0x3Ac8FD1BA33eAC80D37Bfdc51bC10B6C7a4a38B8",
    version: "v1.1",
    name: "Blend Steakhouse High Yield USDC V1",
    symbol: "blend-bbqUSDC-v1",
    asset: {
      address: "0x5c0C306Aaa9F877de636f4d5822cA9F2E81563BA",
      symbol: "bbqUSDC",
    },
  },
  {
    id: "0x9ABE4959BDd33B934D0250bc009a41248eAe2d18",
    version: "v1.1",
    name: "Roy",
    symbol: "Roy",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0x8293026f4835E7e69093F4aca9D80B916930ec47",
    version: "v1.1",
    name: "Pocky's High Yield USDC",
    symbol: "PHYUSDCARB",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x2D91466BCC6946B58869fE2ae521A856737C3f6e",
    version: "v1.1",
    name: "UltraYield USDC",
    symbol: "edgeUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x1FaEe72c301919DdB33CbF36A5c8ab8Da886594d",
    version: "v1.1",
    name: "NALTESTUSDC",
    symbol: "NALTESTUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x6ED14e086c28fDb951a2297907DB9893FFAD7987",
    version: "v1.1",
    name: "USDCtestYield",
    symbol: "ktestUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x5011849f4BDaE6906639428290D886166DD2f274",
    version: "v1.1",
    name: "DeFiAM Core USDC",
    symbol: "DFUSD",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x97e429C9b2d177C6e7570893Cf80Bd4EbEC2243f",
    version: "v1.1",
    name: "0xDataWolf Points Farm",
    symbol: "🐺FARM",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x61A9bd201827FA93f2e0236ED83258028cECBa59",
    version: "v1.1",
    name: "Unstablecoin",
    symbol: "UNSTABLE",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xaE73875437c86abb60cD7fA77286D63cb94F9a25",
    version: "v1.1",
    name: "HexaOne USDC",
    symbol: "hxUSDCa",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xDa59B4682Fe0F5C86E041A81E17E64dE6418DA5c",
    version: "v1.1",
    name: "ZZZ",
    symbol: "zzz",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xdAd074C0c9FB7deDA603Fe47De3172aB01C7C28c",
    version: "v1.1",
    name: "Kedao USDC Vault",
    symbol: "KdUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x36AB064fCBfcC87F6D4a25E638468616E0d92D8D",
    version: "v1.1",
    name: "Only Trust",
    symbol: "onlytrust",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xc62E272D2AD5E97467A7364de760F4bd5CFB7eb8",
    version: "v1.1",
    name: "xblt vault",
    symbol: "xblt 001",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xC3415c9231Dad88F8146107372143f6dAE042967",
    version: "v1.1",
    name: "frobUSDC",
    symbol: "frobUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x7E64B3Eec7A2FAF6347d01eB0CB0A552C6D861e1",
    version: "v1.1",
    name: "TestVault",
    symbol: "TV",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x3601921F4DA1a611159E2Dae7FE80dc267df0517",
    version: "v1.1",
    name: "Maxshot USDT0",
    symbol: "Maxshot USDT0",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0xF1867753eB2B8bEf61191F7Ba2c29f21b84460Ea",
    version: "v1.1",
    name: "testies vault",
    symbol: "testiestesties",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xAc86fF4F00Fa71f3ECE98D9FD5E605330389F81F",
    version: "v1.1",
    name: "vault 123",
    symbol: "vault 123",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xd2d46099B70880e268B0c7557b9D22d3AA848654",
    version: "v1.1",
    name: "usdc staging",
    symbol: "gtstgusdc",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xb6dE3D3E0Cbda197486034bcB2F943147Ba68e51",
    version: "v1.1",
    name: "MCUSDC",
    symbol: "MCUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x1b301f95daC50dAE2fedcc2CBA022062e64E217A",
    version: "v1.1",
    name: "Test-Vault_AE",
    symbol: "TVAE",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xF7437DaF50C798ED2415BbDD9Bdf430bB5e62690",
    version: "v1.1",
    name: "Trinity Gold USDC Vault",
    symbol: "tgUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x63c526fBDF42e0D72dF57370e5778398e5816eD8",
    version: "v1.1",
    name: "Trinity Gold USDC Vault",
    symbol: "tgUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x31ca4986f376e1c935d3dCc2B2BF3CCE7931c6dA",
    version: "v1.1",
    name: "Trinity Gold USDC Vault",
    symbol: "tgUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x7e939C4ba82BB99CC4c0dd79977b1883AF0AF678",
    version: "v1.1",
    name: "Trinity Gold USDC Vault",
    symbol: "tgUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xFB36380a9908e234A3F4F48Fc3d6226a7bC2d8af",
    version: "v1.1",
    name: "Trinity Gold USDC Vault",
    symbol: "tgUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x703B3d1a4813E7729FB82AD05016481a112b5b01",
    version: "v1.1",
    name: "Trinity Gold USDC Vault",
    symbol: "tgUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xF9a4D875811682C225dB58D9d0216709dCD6eBBb",
    version: "v1.1",
    name: "Trinity Gold USDC Vault",
    symbol: "tgUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x4d87C18b7b3b64d79ee28745701620f658c21341",
    version: "v1.1",
    name: "Trinity Gold USDC Vault",
    symbol: "tgUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x3577f216908BE1DB18EbF094f6A5dc1eDd542002",
    version: "v1.1",
    name: "Parity High Yield USDC",
    symbol: "pcHYUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xa47C5203d22Ae173788a9d9Be0F2bEeCc97F4dF9",
    version: "v2",
    name: "Blend USDC Reserve",
    symbol: "blend-usdc-reserve",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x2A7F06e9fdE9Ddc713789Ef18b4A5A7322F555a0",
    version: "v2",
    name: "Blend PT thBILL 27NOV2025",
    symbol: "blend-PT-thBILL-27NOV2025",
    asset: {
      address: "0x5a791652f3b140d357df072d355a98ab754877D1",
      symbol: "PT-thBILL-27NOV2025",
    },
  },
  {
    id: "0xeE64035d7F469Dfe52df71F6FA17Cbe09a7200f2",
    version: "v2",
    name: "Blend PT USDai 20NOV2025",
    symbol: "blend-PT-USDai-20NOV2025",
    asset: {
      address: "0x8b4Ca42bB3B1d789859f106222CF7DC5EEd48CCb",
      symbol: "PT-USDai-20NOV2025",
    },
  },
  {
    id: "0x1107288527Ff3C814757cfcb7B5c681eAcDfA931",
    version: "v2",
    name: "Blend PT thBILL 27NOV2025",
    symbol: "blend-PT-thBILL-27NOV2025",
    asset: {
      address: "0x5a791652f3b140d357df072d355a98ab754877D1",
      symbol: "PT-thBILL-27NOV2025",
    },
  },
  {
    id: "0xaaFbf21Ef7C2D188C5b20dF10C2B1bf94B5c78c0",
    version: "v2",
    name: "Blend Euler Earn USDC",
    symbol: "blend-eeUSDC",
    asset: {
      address: "0xe4783824593a50Bfe9dc873204CEc171ebC62dE0",
      symbol: "eeUSDC",
    },
  },
  {
    id: "0x6d6d4D5010A7606FC7dD83df927A6684Aa394B74",
    version: "v2",
    name: "Blend Hyperithm USDC",
    symbol: "blend-hyperUSDC",
    asset: {
      address: "0x4B6F1C9E5d470b97181786b26da0d0945A7cf027",
      symbol: "hyperUSDC",
    },
  },
  {
    id: "0x207195DfA461868a616F9280708a1C77d24e19EF",
    version: "v2",
    name: "Blend Gauntlet USDC Core",
    symbol: "blend-gtUSDCc",
    asset: {
      address: "0x7e97fa6893871A2751B5fE961978DCCb2c201E65",
      symbol: "gtUSDCc",
    },
  },
  {
    id: "0x69E6160aD95a9C751b385f3094Bd6cDb7ED84521",
    version: "v2",
    name: "Blend MEV Capital USDC",
    symbol: "blend-MCUSDC",
    asset: {
      address: "0xa60643c90A542A95026C0F1dbdB0615fF42019Cf",
      symbol: "MCUSDC",
    },
  },
  {
    id: "0x5818359fa0f44A3F0EFB37057bA383671E747f25",
    version: "v2",
    name: "Blend WETH",
    symbol: "blend-weth",
    asset: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0x62BDA6a9f801DB7A06BBb398638d17b98fC6E450",
    version: "v2",
    name: "Blend Test",
    symbol: "blend-test",
    asset: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0xf3809e56Dcd87DA3Cf1F96A071fF0d5ABd73f683",
    version: "v2",
    name: "Blend Test 2",
    symbol: "blend-test-2",
    asset: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0x28CD883aa8a3a234Ce76A3B8a26511A142f0C293",
    version: "v2",
    name: "Blend test 2",
    symbol: "blend-test-2",
    asset: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0x0dfd6DCc9F13A1B0793B22cF7CfC929A9493DF35",
    version: "v2",
    name: "test",
    symbol: "test1",
    asset: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0x8e2Ba11Ceaa5C6BD8C3eAbB1b62e31d36c955241",
    version: "v2",
    name: "Blend Hyperithm USDC",
    symbol: "blend-hyperUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xF1Ebc1D262F99398BBfaf090519eE82f073d9cD0",
    version: "v2",
    name: "Blend Hyperithm USDC",
    symbol: "blend-hyperUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x96E3800fe5c387750aD7435Ab78698BC5ec9B39d",
    version: "v2",
    name: "Blend Gauntlet USDC Core",
    symbol: "blend-gtUSDCc",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xe2f6DE763b77a897feDa7943f65Ff25f1Fef8932",
    version: "v2",
    name: "Blend Euler Earn USDC",
    symbol: "blend-eeUSDC",
    asset: {
      address: "0xe4783824593a50Bfe9dc873204CEc171ebC62dE0",
      symbol: "eeUSDC",
    },
  },
  {
    id: "0x14ACcDcd16140D44Ffc962D586c750D411829A6f",
    version: "v2",
    name: "Blend Gauntlet USDC Core",
    symbol: "blend-gtUSDCc",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x4C20c82FFCB0ea5F58eb4620d2F212D8879B7C03",
    version: "v2",
    name: "Blend Gauntlet USDC Core",
    symbol: "blend-gtUSDCc",
    asset: {
      address: "0x7e97fa6893871A2751B5fE961978DCCb2c201E65",
      symbol: "gtUSDCc",
    },
  },
  {
    id: "0xd4400F8E077ab585840DE3A8c575b86c9a68D9C2",
    version: "v2",
    name: "Blend MEV Capital USDC",
    symbol: "blend-MCUSDC",
    asset: {
      address: "0xa60643c90A542A95026C0F1dbdB0615fF42019Cf",
      symbol: "MCUSDC",
    },
  },
  {
    id: "0xB2d1EE9a49Bb9813e1464311159B1FC8fF294791",
    version: "v2",
    name: "Blend Steakhouse High Yield USDC",
    symbol: "blend-bbqUSDC",
    asset: {
      address: "0x5c0C306Aaa9F877de636f4d5822cA9F2E81563BA",
      symbol: "bbqUSDC",
    },
  },
  {
    id: "0xA1Bc1D1a68B4c1721a65188e763E40bf44f79443",
    version: "v2",
    name: "Blend Steakhouse High Yield USDC",
    symbol: "blend-bbqUSDC",
    asset: {
      address: "0x5c0C306Aaa9F877de636f4d5822cA9F2E81563BA",
      symbol: "bbqUSDC",
    },
  },
  {
    id: "0xdCdd105E252E8cF685fb910FD9B2172cA3535a7F",
    version: "v2",
    name: "WETH TEST",
    symbol: "weth-test",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xeCd5a2676d78E0C93EE4D09c9D397B9043Eff72D",
    version: "v2",
    name: "test usdc",
    symbol: "test-usdc",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x7AaB1A24201Ce87Df20F095ac31f3187FABB9AC5",
    version: "v2",
    name: "test",
    symbol: "test",
    asset: {
      address: "0x7e97fa6893871A2751B5fE961978DCCb2c201E65",
      symbol: "gtUSDCc",
    },
  },
  {
    id: "0x9cE8A73296704d4689586347eF6e2087c2128F45",
    version: "v2",
    name: "Blend USDC",
    symbol: "blend-usdc",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x05597ECd2af27A03D2d175658C13272fc6FaA378",
    version: "v2",
    name: "Blend Aave USDC",
    symbol: "blend-aave-usdc",
    asset: {
      address: "0x724dc807b04555b71ed48a6896b6F41593b8C637",
      symbol: "aArbUSDCn",
    },
  },
  {
    id: "0x75E9d4FEa6c408097eE4F3C63359D0dc617AcB4F",
    version: "v2",
    name: "Blend PT USDai 19FEB2026",
    symbol: "blend-PT-USDai-19FEB2026",
    asset: {
      address: "0x5B2C615E22272234AACF187632a0531cA1243279",
      symbol: "PT-USDai-19FEB2026",
    },
  },
  {
    id: "0x567c1B5c2E58C66f84B80dff4C97b084B23B4E87",
    version: "v2",
    name: "Blend PT sUSDai 19FEB2026",
    symbol: "blend-PT-sUSDai-19FEB2026",
    asset: {
      address: "0x1BF1311FCF914A69Dd5805C9B06b72F80539cB3f",
      symbol: "PT-sUSDai-19FEB2026",
    },
  },
  {
    id: "0x32819ebBd29AAe745AB3e172892e749AebEb889E",
    version: "v2",
    name: "Blend Aave USDC",
    symbol: "blend-aave-usdc",
    asset: {
      address: "0x724dc807b04555b71ed48a6896b6F41593b8C637",
      symbol: "aArbUSDCn",
    },
  },
  {
    id: "0xfd3B6dE1EaeEb3e8CAdD125BfC8Aec492A5C542F",
    version: "v2",
    name: "Blend Aave USDC",
    symbol: "blend-aave-usdc",
    asset: {
      address: "0x7F6501d3B98eE91f9b9535E4b0ac710Fb0f9e0bc",
      symbol: "waArbUSDCn",
    },
  },
  {
    id: "0xE3637cA4D1D6dD756dE0ecd527c40077029eCE6e",
    version: "v2",
    name: "Blend PT-thBILL-19FEB2026",
    symbol: "blend-PT-thBILL-19FEB2026",
    asset: {
      address: "0x9b3924f9652cabf3Db48B7B4C92E474c571B3Ab4",
      symbol: "PT-thBILL-19FEB2026",
    },
  },
  {
    id: "0x129D54d442a32f3aE931F894c7b58B93F4E78846",
    version: "v2",
    name: "Steakhouse Prime USDC",
    symbol: "SPUC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x942aC0427dee0E0B5f0b9A447c973D8D902931F8",
    version: "v2",
    name: "Testor",
    symbol: "$test",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x46a50376c31913b497088D2d420e25DE43F7033c",
    version: "v2",
    name: "SH1 Multi-Asset",
    symbol: "sh1MULTI",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x075b7C9E880b3dd9DB9523Bf47803C415E89F833",
    version: "v2",
    name: "Test Vault 123",
    symbol: "testingtestingtest",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x62ddba038c65bA6590bA5e56B77F0F33722b851E",
    version: "v2",
    name: "test 1234",
    symbol: "testest",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeeff77CE5C059445714E6A3490E273fE7F2492F",
    version: "v2",
    name: "Bitget x Steakhouse USDT",
    symbol: "bitgetUSDT0",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0xbeeff1D5dE8F79ff37a151681100B039661da518",
    version: "v2",
    name: "Bitget x Steakhouse USDC",
    symbol: "bitgetUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xBbd4B5bE672c3034eB000576Ff17b4A3F2390b4d",
    version: "v2",
    name: "Steakhouse High Yield Turbo",
    symbol: "ptUSDCturbo",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x7202c834bC63A22E4A5950F04510b25552d59986",
    version: "v2",
    name: "Steakhouse High Yield Turbo",
    symbol: "ptUSDCturbo",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x56b476b6007FeE6317b65C19Ab1186Ef1cb6ce3A",
    version: "v2",
    name: "Steakhouse High Yield Turbo",
    symbol: "ptUSDCturbo",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xBEEFFF13dD098De415e07F033daE65205B31A894",
    version: "v2",
    name: "Steakhouse High Yield Turbo",
    symbol: "ptUSDCturbo",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xAF0C3B2784b6978Fdf6659660a85Cb255Fb8da30",
    version: "v2",
    name: "Pump yield",
    symbol: "USDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x0E1D62252ec310233816Effdcd7f99cf40Fe2206",
    version: "v2",
    name: "tsla123",
    symbol: "tsla",
    asset: {
      address: "0x8aD3c73F833d3F9A523aB01476625F269aEB7Cf0",
      symbol: "TSLAx",
    },
  },
  {
    id: "0x3e4E27C55d488CC8e1D9D6a59Dcf65283A2464BF",
    version: "v2",
    name: "cmg Test Vault",
    symbol: "cmgTest",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x27B5e60eab54eB202DB5ec7d0810c0686afF60e6",
    version: "v2",
    name: "Gauntlet USDC Prime",
    symbol: "gtusdcp",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x7c46d039BD558F31147388770B44a33C4Aaf3B25",
    version: "v2",
    name: "Gauntlet USDC Prime",
    symbol: "gtusdcp",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x610D151aE40662AE148cdBaaE1Ea5904b6AFAE78",
    version: "v2",
    name: "Gauntlet USDC Prime",
    symbol: "gtusdcp",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x5007D4b8F1BC2b0541006a9dE22498710DBD7174",
    version: "v2",
    name: "Gauntlet USDC Balanced",
    symbol: "gtusdcb",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x55a2B207b0074E13AdCb858950a81B7a04775E0F",
    version: "v2",
    name: "Gauntlet USDC Balanced",
    symbol: "gtusdcb",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x670C270A27f64Ece248dE8055fA8A3eEF4D56C96",
    version: "v2",
    name: "Blend xChain USDC",
    symbol: "blend-xchain-usdc",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x6A4e8a3119170F1E97BDC0fBF115D67f83E40560",
    version: "v2",
    name: "Blend USDC/​EURe",
    symbol: "blend-usdc-​eure",
    asset: {
      address: "0xfE1B89A891E97A964291E43E89097e0Ddf90e266",
      symbol: "wmooBalancerArbitrumwaArbUSDCn/EURe",
    },
  },
  {
    id: "0x5837e4189819637853a357aF36650902347F5e73",
    version: "v2",
    name: "KPK USDC Yield",
    symbol: "KPK_USDC_Yield",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x2A983b049668810700c6768373DDccf8A9F24DA9",
    version: "v2",
    name: "Steakhouse High Yield USDC",
    symbol: "stUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x02641594dd0710f9eCBab6f5D37da121620D38a0",
    version: "v2",
    name: "SteakHouse USDC High Yield",
    symbol: "SPL",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xC8B32063b93C1D59d046cf3cbAe848Dda11B265B",
    version: "v2",
    name: "albist USDC",
    symbol: "albist",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x26986194cE9d2B8442E25e36128F8339E7956041",
    version: "v2",
    name: "SteakHouse USDC Prime",
    symbol: "SPL2",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x0f2a2beBfd030A054292517817fF30141f552E9e",
    version: "v2",
    name: "Dummy",
    symbol: "Dummy",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xf75A7c834AeF317e5A36dcAb99e0771446547B39",
    version: "v2",
    name: "Dummy",
    symbol: "DUMMY",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0x766FE593288DDb5cE330cDDa3F6B15C23d47B260",
    version: "v2",
    name: "Dummy",
    symbol: "DUMMY",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0x989dE1a62b6a668A14C158240BEF8418A979b9BC",
    version: "v2",
    name: "Dummy",
    symbol: "DUMMY",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x9a37fFD04d980f34819eae4fD99420dA590e86C0",
    version: "v2",
    name: "K3 High Yield USDC",
    symbol: "k3hyUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xD6498273ce6b14DC493CDE520c67a6A69253C6D3",
    version: "v2",
    name: "SteakHouse USDT High Yield",
    symbol: "SFP3",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0x248e0DFCf7E7020f5CB9fAaB2C2547F183ea612C",
    version: "v2",
    name: "kdfksfkj",
    symbol: "kfjdkfjs",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x9f887B60295500B840D890F985ECCf8b870364d8",
    version: "v2",
    name: "Blend xChain USDC Reserve",
    symbol: "blend-xchain-usdc-reserve",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xae1ae3dAC810136e97003b6Aa0BeF5B064Ce8FaD",
    version: "v2",
    name: "Duplicated Key Arb",
    symbol: "DPK.ARB.v2",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xB16F63bB4346d6099286Bb855f51478D58f155F9",
    version: "v2",
    name: "Maxshot USDT0",
    symbol: "mUSDT0",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0x707e4A3454977365e39139D1256fb0cCb4bE5D41",
    version: "v2",
    name: "Maxshot USDC",
    symbol: "mUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xdE072b494d757041548F2c9c95DCf2B7F12F55b9",
    version: "v2",
    name: "HavenFi High Yield USDC",
    symbol: "HFHY",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x48d2D31B16D9e9ca392307A828dEeA2B7E193b39",
    version: "v2",
    name: "Steakhouse High Yield Turbo",
    symbol: "bbqXAUT0turbo",
    asset: {
      address: "0x40461291347e1eCbb09499F3371D3f17f10d7159",
      symbol: "XAUt0",
    },
  },
  {
    id: "0x45cE56b690828bEa6b69A4Bd62A18FccDd88f167",
    version: "v2",
    name: "Blend xChain PT-sUSDai-19FEB2026",
    symbol: "b-xchain-pt-sUSDai-19feb2026",
    asset: {
      address: "0x1BF1311FCF914A69Dd5805C9B06b72F80539cB3f",
      symbol: "PT-sUSDai-19FEB2026",
    },
  },
  {
    id: "0x385a26306dD51B6719A567d9C26707F891318A98",
    version: "v2",
    name: "Blend xChain  PT-thBILL-19FEB2026",
    symbol: "b-xchain-pt-thBILL-19feb2026",
    asset: {
      address: "0x9b3924f9652cabf3Db48B7B4C92E474c571B3Ab4",
      symbol: "PT-thBILL-19FEB2026",
    },
  },
  {
    id: "0xBEEFFFFE0E9b26bBe3B5cE851539366991C3BF39",
    version: "v2",
    name: "Steakhouse High Yield Turbo XAUt0",
    symbol: "bbqXAUT0turbo",
    asset: {
      address: "0x40461291347e1eCbb09499F3371D3f17f10d7159",
      symbol: "XAUt0",
    },
  },
  {
    id: "0x0e1023647db0b5E7136B3B7Cfa885ee698a3d861",
    version: "v2",
    name: "ArbiAutoUSD",
    symbol: "aaUSD",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x91CA976fFd86B0df6AD7C73C4C277430EaAb3852",
    version: "v2",
    name: "ARCHITECT Global Value",
    symbol: "ARCHITECT GVI",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x0da9Bf22117e6904bEbb380556aC53C45093a289",
    version: "v2",
    name: "Strategic USDC Yield Vault",
    symbol: "STGY",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x67febc24c4332e3dbfF99A5db9cAd3f78B749d5D",
    version: "v2",
    name: "Safe USDC Arbitrum",
    symbol: "sUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x60fEd8Cf72b435EA5457Fe45073c86Ab77dF7Df1",
    version: "v2",
    name: "SafeUSDC Arbitrum",
    symbol: "sUSDC-ARB",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xc6cC80342FBC79f212ce264dC3234Ced48802356",
    version: "v2",
    name: "SHAWERMA",
    symbol: "SHAWERMA",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xBBa724CA3a0385B9b8816885203fe72C3c37aF1B",
    version: "v2",
    name: "Safe Capital",
    symbol: "Arbitrum",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xeA07e6af50A6FADe4934a4484C586d753d3cbDe7",
    version: "v2",
    name: "Prime  Safe Vault",
    symbol: "USDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x8D5e0B9Edc0D02F915fa03d023f940C9B529C6A8",
    version: "v2",
    name: "Morpho AI Agent Vault",
    symbol: "aiUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x36Cac2Ab8b4ab84AFDd322E191993d18F16bCfF2",
    version: "v2",
    name: "Test vault",
    symbol: "TEST",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0xb3E077643A1bbbeC59158fe954a4CbB09fDc6162",
    version: "v2",
    name: "MCUSDC",
    symbol: "MCUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x2756F3BF97A8f17aE081F4E94a18dF0ed601A82E",
    version: "v2",
    name: "hhUFT jj",
    symbol: "hhUFT",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0x97999089f3647F916e8c0Fb45110732a5590805d",
    version: "v2",
    name: "Weret",
    symbol: "WOHOO",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0x4a16a3e2dD76D45821821260c64D92Bb6f66cC84",
    version: "v2",
    name: "Mesa Prime USDC",
    symbol: "mesa-prime-usdc",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xb78fd294E1C069De6862dF1110fF9e92948F2457",
    version: "v2",
    name: "LFGGGGG",
    symbol: "LFG",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0x64122Af84Ea1731DB3fd3cc15a8C1c031b8EA7eb",
    version: "v2",
    name: "SHAVA",
    symbol: "SW",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0x0031b5cFB9eD0Bd74A2361460C5484A31cDdf764",
    version: "v2",
    name: "Blend High Yield USDC",
    symbol: "blend-high-yield-usdc",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x2abDC57E8f16f6a3dfD74160Bb9BA212820D98d6",
    version: "v2",
    name: "Blend PT sUSDai 18JUN2026",
    symbol: "blend-PT-sUSDai-18JUN2026",
    asset: {
      address: "0x07bc5bD6cE9A17f0e7aa91E0Adbc9070dcB1d1dE",
      symbol: "PT-sUSDai-18JUN2026",
    },
  },
  {
    id: "0xb0d4Fa3A63b1DAE2724CF1259b75886cf444f299",
    version: "v2",
    name: "Blend PT sUSDai 15OCT2026",
    symbol: "blend-PT-sUSDai-15OCT2026",
    asset: {
      address: "0xB459dB106f645d698E74027eeF6019A26a0675Cc",
      symbol: "PT-sUSDai-15OCT2026",
    },
  },
  {
    id: "0x2f417Eb0c4031E4313cFE20377dec8DA96a90A78",
    version: "v2",
    name: "Blend PT thBILL 18JUN2026",
    symbol: "blend-PT-thBILL-18JUN2026",
    asset: {
      address: "0xE46271ecb1d5c7c5134868760F10c18B03021eF1",
      symbol: "PT-thBILL-18JUN2026",
    },
  },
  {
    id: "0x8e498D5Ab18237f02ACe15a2Bc283C544635F0c5",
    version: "v2",
    name: "hjjhkjhkj",
    symbol: "zxff",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0xb755Adb9F4875F24B5CFEbA47F745d3d1AD739a1",
    version: "v2",
    name: "Blend PT thBILL 18JUN2026",
    symbol: "blend-PT-thBILL-18JUN2026",
    asset: {
      address: "0xE46271ecb1d5c7c5134868760F10c18B03021eF1",
      symbol: "PT-thBILL-18JUN2026",
    },
  },
  {
    id: "0x16e715a5D8d37c78F006ea151Fc73F6eC9c63414",
    version: "v2",
    name: "Blend PT sUSDai 15OCT2026",
    symbol: "blend-PT-sUSDai-15OCT2026",
    asset: {
      address: "0xB459dB106f645d698E74027eeF6019A26a0675Cc",
      symbol: "PT-sUSDai-15OCT2026",
    },
  },
  {
    id: "0x7b41Bc63676A987638ee6F5Ddb3Fe39072341623",
    version: "v2",
    name: "My Fee Wrapper 123",
    symbol: "MFW123",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x1eDC5Cb82feAF0e90569bECaC2e52798015c66F2",
    version: "v2",
    name: "PACAP USDC",
    symbol: "pacapUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xc084924fC75c719a38d453532b1Be687E89961b4",
    version: "v2",
    name: "Alpha USDT Test V2",
    symbol: "aUSDTv2",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0x26475c4623250dE2da9f9aE907a2AA178d98AEE2",
    version: "v2",
    name: "Philidor USDC Prime Arbitrum",
    symbol: "philidor-usdc-prime-arbitrum",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xF476D6B4e3Fa80C97aA42247db4C779f17C41A4b",
    version: "v2",
    name: "Pagga Arbitrum USDC",
    symbol: "pagga-arbitrum-usdc",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x84eAa12b88519d567d9811Dd4434D2e7b6AB13Ad",
    version: "v2",
    name: "Test",
    symbol: "TST",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0x1e7F0372dd54B224130db49ec26854aFAF1eBca2",
    version: "v2",
    name: "Sherpa Direct",
    symbol: "SED",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x5460D9D0ba8A7a1c1Ecd0ebf1445e161025eE9D4",
    version: "v2",
    name: "TEST2",
    symbol: "test2",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0xE93234eB6491411F5a82f6f3fbec0196FC981620",
    version: "v2",
    name: "TestVault",
    symbol: "DTV",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x4F38e7a76b9C32Ab68FBf500E4d52806B15AB93b",
    version: "v2",
    name: "Pods USDC Yield by KPK",
    symbol: "podsUSDCy",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x3526F7998AA78d6513faB53f203CA132B2656890",
    version: "v2",
    name: "myz1237",
    symbol: "YZ",
    asset: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0x56CD44fdD14141F8297eFFaa2c0387445f242De8",
    version: "v2",
    name: "Bloom Active",
    symbol: "BID",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xf26E3AD205a1Dd3617D969f00238a7511CedC761",
    version: "v2",
    name: "Bloom Arbitrum USDC",
    symbol: "BLOOMARBITRUMUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x7eB33cF4808f1D04Efc7ecFff2bdeaA23960d71e",
    version: "v2",
    name: "Resilience Asset Strategy",
    symbol: "MacroRAS",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x2f3b870B3a02bd10A63D8f6B4490A31B35ba897E",
    version: "v2",
    name: "Arbitrum USDC",
    symbol: "arbitrum-usdc",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeeff96dD606189562dDBBdE0cdB1c13f984680b",
    version: "v2",
    name: "Steakhouse High Yield USDC",
    symbol: "bbqUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeefff50b7Bb6D1a6c6A9b97b60b5cAa24B6b5CC",
    version: "v2",
    name: "Steakhouse High Yield USDT",
    symbol: "bbqUSDT",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0xA07FC91439A8BE56119A8429Bf3836a4FAf94d02",
    version: "v2",
    name: "Prism Steakhouse USDC",
    symbol: "PrismShUSDC",
    asset: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x321EBcC5E7b634E51529D5C39e71E4b5c00d712A",
    version: "v2",
    name: "Prism Steakhouse USDT",
    symbol: "PrismShUSDT",
    asset: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
] as const
